// @flow
import * as React from 'react';
import 'app/common/react/components/profile/showcase/ShowcasePips/ShowcasePips.scss';
import cx from 'classnames';
import PropTypes from 'prop-types';

type ShowcasePipsType = {
  currentPipIndex: number,
  numberPips: number,
};

export default function ShowcasePips(props: ShowcasePipsType) {
  const { currentPipIndex, numberPips } = props;
  if (currentPipIndex >= numberPips) {
    return null;
  }
  return (
    <div className="ShowcasePips flex">
      {Array(numberPips)
        .fill()
        .map((_, i) => {
          if (i === currentPipIndex) {
            return (
              <div className="animatingPipWrapper" key={i}>
                <div className="pip" />
                <div className="pip animatingPip" />
              </div>
            );
          }

          return <div className={cx('pip', { filledPip: i < currentPipIndex })} key={i} />;
        })}
    </div>
  );
}

ShowcasePips.propTypes = {
  currentPipIndex: PropTypes.number.isRequired,
  numberPips: PropTypes.number.isRequired,
};
